import React, { SVGAttributes } from 'react';

export function NotificationIcon(props: SVGAttributes<unknown>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none' {...props}>
      <path
        d='M6.89118 14.0548C6.6934 14.2525 6.42519 14.3636 6.14552 14.3636C5.86586 14.3636 5.59764 14.2525 5.39985 14.0548L1.61774 10.2733C1.51974 10.1754 1.44199 10.0591 1.38895 9.93113C1.3359 9.80309 1.30859 9.66591 1.30859 9.52733C1.30859 9.38881 1.3359 9.25156 1.38895 9.12359C1.44199 8.99555 1.51974 8.87926 1.61774 8.78131L9.00057 1.39851C9.09852 1.3006 9.21488 1.22293 9.34285 1.16997C9.47089 1.11701 9.60807 1.08978 9.74659 1.08984H13.528C13.8077 1.08984 14.0759 1.20096 14.2737 1.39875C14.4715 1.59655 14.5827 1.86481 14.5827 2.14453V5.92664C14.5826 6.20617 14.4716 6.47423 14.274 6.67195'
        stroke='#3387E1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.9453 3.98828C11.7997 3.98828 11.6816 3.87023 11.6816 3.72461C11.6816 3.57899 11.7997 3.46094 11.9453 3.46094'
        stroke='#3387E1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.9453 3.98828C12.0909 3.98828 12.209 3.87023 12.209 3.72461C12.209 3.57899 12.0909 3.46094 11.9453 3.46094'
        stroke='#3387E1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M12.4727 8.82206V7.85547' stroke='#3387E1' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M12.4718 8.82031C13.3264 8.82031 14.1459 9.15977 14.7501 9.76401C15.3543 10.3682 15.6938 11.1878 15.6938 12.0423C15.6938 15.0692 16.3382 15.5864 16.3382 15.5864H8.60547C8.60547 15.5864 9.24986 14.7633 9.24986 12.0423C9.24986 11.1878 9.58932 10.3682 10.1936 9.76401C10.7978 9.15977 11.6173 8.82031 12.4718 8.82031Z'
        fill='#99C3F0'
        stroke='#3387E1'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect x='12' y='16' width='1' height='1' stroke='#3387E1' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
